<template>
    <Layout>
        <ContractedBooksList />
    </Layout>
</template>

<script>
import { ContractedBooksList } from '@speechki-frontend/core/book/components';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';

export default {
    name: 'ContractedBooksPage',
    components: {
        ContractedBooksList,
        Layout
    },
    created() {
        if (
            !this.$store.getters.isAdmin &&
            !this.$store.getters.isStaff &&
            !this.$store.getters.isListener
        ) {
            this.$router.replace({ name: 'home' });
        }
    }
};
</script>
